export default "__VITE_ASSET__B9iezoVI__"